import clsx from 'clsx';
import React from 'react';

export type FootnoteItemProps = FootnoteItemBase;

interface FootnoteItemBase {
  type: string;
  content: React.ReactChild;
  id?: number;
  showIdentifier?: boolean;
}

const FootnoteItem: React.FC<FootnoteItemProps> = (
  props: FootnoteItemProps
) => {
  const { content, type, id, showIdentifier = false } = props;

  // const intl = useIntl();

  const className = {
    footnoteId: clsx('-left-15px absolute'),
    footnoteItem: clsx('mb-5px relative', showIdentifier ? 'ml-15px' : ''),
  };

  const { footnoteId, footnoteItem } = className;

  return (
    <li id={`aa-footnote-${type}`} className={footnoteItem}>
      {showIdentifier && <span className={footnoteId}>{id}</span>}
      <div id={`label--footnoteItem-${id}`}>{content}</div>
    </li>
  );
};

export default FootnoteItem;
